import { FC } from 'react';
import ClientDetailsTemplate from '~src/components/templates/ClientDetailsTemplate/ClientDetailsTemplate';

// interface DashboardProps {}

const ClientDetails: FC = () => <ClientDetailsTemplate />;

export default ClientDetails;
